import { Component, OnInit, OnChanges, Input, HostListener, ElementRef, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { EMPTY, Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { LocationsTurnsService } from 'src/app/services/turns-services/locations-turns-service/locations-turns.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { catchError, tap } from 'rxjs/operators';

@Component({
  selector: 'app-turns-location-info-card',
  templateUrl: './turns-location-info-card.component.html',
  styleUrls: ['./turns-location-info-card.component.scss']
})
export class TurnsLocationInfoCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() location;
  centerList;
  editingLocked;
  availableStatus;
  availableIotDevices;
  updateLocationSubscription: Subscription;
  refreshLocationListenSubscription: Subscription;
  iotDeviceSubscription: Subscription;
  basicDataForm = new FormGroup({
    active: new FormControl({ value: true, disabled: true }, Validators.required),
    selectedCenter: new FormControl({ value: null, disabled: true }, Validators.required),
    name: new FormControl({ value: null, disabled: true }, Validators.required),
    number: new FormControl({ value: null, disabled: true }, Validators.required),
    selectedStatus: new FormControl({ value: null, disabled: true }, Validators.required),
    selectedIotDevice: new FormControl({ value: null, disabled: true }, Validators.required)
  });

  constructor(private userStorageService: UserStorageService,
    private eRef: ElementRef,
    private locationsTurnsService: LocationsTurnsService,
    private centerService: CentersCentersService,
    private translateService: TranslateService,
    private snackbarService: SnackBarService,
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.lockEdition();
    this.availableStatus = [{ InternalId: 'AVAIABLE', value: 'AVAIABLE' }, { InternalId: 'ATTENDING', value: 'ATTENDING' }, { InternalId: 'CLOSED', value: 'CLOSED' }];
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.refreshLocationListenSubscription = this.locationsTurnsService.refreshLocationListen().subscribe(
      (res) => {
        this.resetForm();
      }
    );
  }

  ngOnChanges() {
    if (this.location && this.centerList && this.availableStatus) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path && event.path[0].className !== 'mat-option-text') {
        if (this.location && this.availableStatus && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public getIotDevices() {
    this.fetchIotDevices(this.getSelectedCenterInternalId());
  }

  public fetchIotDevices(centerInternalId) {
    this.iotDeviceSubscription = this.centerService.getIotDevices(centerInternalId).pipe(
      tap(o => {
        this.availableIotDevices = o;
        this.basicDataForm.patchValue({
          selectedIotDevice: this.setSelectedIotDevice()
        });
      }),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public submitForm() {
    this.updateLocationSubscription = this.locationsTurnsService.updateLocation(this.location.InternalId, this.basicDataForm.get('active').value, this.getSelectedCenterInternalId(), this.basicDataForm.get('name').value, this.basicDataForm.get('number').value, this.getSelectedStatus(), this.getSelectedIotDevice()).subscribe(
      (res) => {
        this.lockEdition();
        this.locationsTurnsService.refreshLocation();
        this.snackbarService.open('turns-page.snackbar messages.update location success', 'success');
        this.router.navigate(['../locations'], { relativeTo: this.activatedRoute.parent });
      },
      (error) => {
        this.lockEdition();
        this.locationsTurnsService.refreshLocation();
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getStatus(id) {
    if (this.location) {
      const status = this.availableStatus.filter(s => s.InternalId === id);
      if (status && (status.length === 1)) {
        return this.translateService.instant(status[0].value);
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  private validateForm() {
    if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'turns-page.snackbar messages.selected center location error';
    } else if (!this.basicDataForm.get('name').valid) {
      return 'turns-page.snackbar messages.name location error';
    } else if (!this.basicDataForm.get('number').valid) {
      return 'turns-page.snackbar messages.number location error';
    } else if (!this.basicDataForm.get('selectedStatus').valid) {
      return 'turns-page.snackbar messages.status location error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      active: this.location.Active,
      selectedCenter: this.setSelectedCenter(),
      name: this.location.Name,
      number: this.location.Numeration,
      selectedStatus: this.setSelectedStatus(),
      selectedIotDevice: this.fetchIotDevices(this.location.CenterInternalId)
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('selectedCenter').enable();
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('number').enable();
    this.basicDataForm.get('selectedStatus').enable();
    this.basicDataForm.get('selectedIotDevice').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('selectedCenter').disable();
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('number').disable();
    this.basicDataForm.get('selectedStatus').disable();
    this.basicDataForm.get('selectedIotDevice').disable();
    this.editingLocked = true;
  }

  public getSelectedCenterInternalId() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public getSelectedStatus() {
    if (this.location) {
      if (this.basicDataForm.get('selectedStatus').value) {
        return this.basicDataForm.get('selectedStatus').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public getSelectedIotDevice() {
    if (this.availableIotDevices.length === 1) {
      return this.availableIotDevices[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedIotDevice').value) {
        return this.basicDataForm.get('selectedIotDevice').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public setSelectedCenter() {
    if (this.location && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.location.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedStatus() {
    if (this.location && this.availableStatus) {
      for (const status of this.availableStatus) {
        if (status.InternalId === this.location.Status) {
          return status;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedIotDevice() {
    if (this.location && this.availableIotDevices) {
      for (const iotDevice of this.availableIotDevices) {
        if (iotDevice.InternalId === this.location.iotInternalId) {
          return iotDevice;
        }
      }
    } else {
      return null;
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.updateLocationSubscription) { this.updateLocationSubscription.unsubscribe(); }
    if (this.refreshLocationListenSubscription) { this.refreshLocationListenSubscription.unsubscribe(); }
    if (this.iotDeviceSubscription) { this.iotDeviceSubscription.unsubscribe(); }
  }
}
